// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_Og","pageSubTitle":"e_Pg"};